export default __webpack_public_path__ + "static/media/G_Gato.06c4e4b8.mp3";